class Tabs {
    constructor(element) {
        this.element = element
        this.element._tabs = this
        this.tabContent = null
        this.initListeners()
        $(this.tabInputList[0]).click()
    }

    initListeners() {
        $(this.tabInputList).on('change', this.changeTab.bind(this))
    }

    changeTab() {
        this.unsetAllActiveTabs()
        this.setTabActive()
        this.tabContent && $(this.tabContent).trigger('tab:change')
    }

    unsetAllActiveTabs() {
        const tabList = $(this.tabInputList).closest('.js-tab')
        tabList.removeClass('active')
    }

    setTabActive() {
        const tab = $(this.activeTab).closest('.js-tab')
        tab.addClass('active')
    }

    get activeTab() {
        return $(this.element).find('input:checked')
    }

    get tabInputList() {
        return $(this.element).find('input')
    }
}

$('.js-tab-list').each((index, item) => {
    new Tabs(item)
})
